module.exports = __webpack_public_path__ + "3a91af79ae495ab41dc401681733ff1e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-86@2x.png
// module id = 541
// module chunks = 0